import { useState } from 'react';
import { useNavigate, Link } from 'react-router-dom';
import api from '../services/api';
import { toast } from 'sonner';
import { Button } from '../components/ui/button';
import { Input } from '../components/ui/input';
import { Label } from '../components/ui/label';
import { Textarea } from '../components/ui/textarea';
import { Shield, CheckCircle, Clock } from 'lucide-react';

export default function RegisterPage() {
  const [form, setForm] = useState({ company_name: '', admin_email: '', admin_password: '', admin_name: '', phone: '', notes: '' });
  const [loading, setLoading] = useState(false);
  const [submitted, setSubmitted] = useState(false);

  const handleRegister = async (e) => {
    e.preventDefault();
    if (!form.company_name || !form.admin_email || !form.admin_password || !form.admin_name) {
      toast.error('Pflichtfelder ausfüllen'); return;
    }
    setLoading(true);
    try {
      await api.post('/auth/register', form);
      setSubmitted(true);
    } catch (err) {
      toast.error(err.response?.data?.detail || 'Registrierung fehlgeschlagen');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center p-8 bg-background">
      <div className="w-full max-w-sm">
        <div className="mb-8">
          <Link to="/login" className="flex items-center gap-2 hover:opacity-80 transition-opacity">
            <div className="w-8 h-8 bg-primary rounded-sm flex items-center justify-center">
              <Shield className="w-4 h-4 text-primary-foreground" />
            </div>
            <span className="font-heading font-black text-xl tracking-tight">Your Hero</span>
          </Link>
        </div>

        {!submitted ? (
          <>
            <h2 className="font-heading font-bold text-2xl text-foreground mb-1">Zugang beantragen</h2>
            <p className="text-sm text-muted-foreground mb-6">Ihre Anfrage wird vom Administrator geprüft und freigeschaltet.</p>
            <form onSubmit={handleRegister} className="space-y-4" data-testid="register-form">
              <div className="space-y-1.5">
                <Label>Unternehmensname *</Label>
                <Input data-testid="company-name-input" placeholder="Muster Hausverwaltung AG" value={form.company_name} onChange={e => setForm(f => ({ ...f, company_name: e.target.value }))} className="rounded-sm" />
              </div>
              <div className="space-y-1.5">
                <Label>Ihr Name *</Label>
                <Input data-testid="admin-name-input" placeholder="Max Muster" value={form.admin_name} onChange={e => setForm(f => ({ ...f, admin_name: e.target.value }))} className="rounded-sm" />
              </div>
              <div className="space-y-1.5">
                <Label>E-Mail *</Label>
                <Input type="email" data-testid="admin-email-input" placeholder="admin@unternehmen.ch" value={form.admin_email} onChange={e => setForm(f => ({ ...f, admin_email: e.target.value }))} className="rounded-sm" />
              </div>
              <div className="space-y-1.5">
                <Label>Telefon</Label>
                <Input placeholder="+41 79 123 45 67" value={form.phone} onChange={e => setForm(f => ({ ...f, phone: e.target.value }))} className="rounded-sm" />
              </div>
              <div className="space-y-1.5">
                <Label>Passwort *</Label>
                <Input type="password" data-testid="admin-password-input" placeholder="Mindestens 8 Zeichen" value={form.admin_password} onChange={e => setForm(f => ({ ...f, admin_password: e.target.value }))} className="rounded-sm" />
              </div>
              <div className="space-y-1.5">
                <Label>Bemerkung (optional)</Label>
                <Textarea placeholder="Kurze Beschreibung Ihres Unternehmens..." value={form.notes} onChange={e => setForm(f => ({ ...f, notes: e.target.value }))} rows={2} className="rounded-sm resize-none" />
              </div>
              <Button type="submit" data-testid="register-submit-btn" className="w-full rounded-sm" disabled={loading}>
                {loading ? 'Wird gesendet...' : 'Zugang beantragen'}
              </Button>
            </form>
          </>
        ) : (
          <div className="text-center space-y-4" data-testid="register-success">
            <div className="w-16 h-16 bg-amber-100 rounded-sm flex items-center justify-center mx-auto">
              <Clock className="w-8 h-8 text-amber-600" />
            </div>
            <h2 className="font-heading font-bold text-xl">Anfrage eingereicht</h2>
            <div className="bg-muted rounded-sm p-4 text-left text-sm text-muted-foreground">
              <p>Ihre Registrierungsanfrage wurde erfolgreich eingereicht.</p>
              <p className="mt-2">Der Administrator wird Ihre Anfrage prüfen und Sie per E-Mail benachrichtigen, sobald Ihr Konto freigeschaltet wurde.</p>
            </div>
            <Button onClick={() => window.location.href = '/login'} className="w-full rounded-sm" data-testid="go-to-login-btn">
              Zum Login
            </Button>
          </div>
        )}

        {!submitted && (
          <p className="mt-6 text-center text-sm text-muted-foreground">
            Bereits ein Konto?{' '}
            <Link to="/login" className="text-primary hover:underline font-medium relative z-10 inline-block py-2" data-testid="login-link">Anmelden</Link>
          </p>
        )}
      </div>
    </div>
  );
}
